
import type {Schemas} from 'api/dto.generated';
import {ebsApi} from 'store/ebsApi';
import {mapToWorkBaseDto, mapWorkBaseDto, mapWorkFlattenedDto} from './mappers';
import type {WorkMetadata, WorkV4} from './types';

const workApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getWork: build.query<
      WorkMetadata,
      {id: string; mock?: false},
      Schemas.WorkFlattenedDto
    >({
      query: ({id}) => `work/v2/${id}`,
      transformResponse: mapWorkFlattenedDto,
    }),

    getWorkByEan: build.query<WorkMetadata, string, Schemas.WorkFlattenedDto>({
      query: ean => `work/v2/ean/${ean}`,
      transformResponse: mapWorkFlattenedDto,
    }),

    getWorks: build.query<WorkMetadata[], string[], Schemas.WorkFlattenedDtos>({
      query: ids => ({url: `work/v2/id`, method: 'POST', body: {ids}}),
      transformResponse: ({works}) => {
        return (works ?? []).map(mapWorkFlattenedDto);
      },
    }),

    saveWork: build.mutation<WorkV4, WorkV4, Schemas.WorkBaseDto>({
      query: work => ({
        url: `work/${work.id}`,
        method: 'PUT',
        body: mapToWorkBaseDto(work),
      }),
      transformResponse: mapWorkBaseDto,
    }),
  }),
});

export const {
  useGetWorkQuery,
  useLazyGetWorkQuery,
  useGetWorkByEanQuery,
  useLazyGetWorksQuery,
  useSaveWorkMutation,
} = workApi;
